import React, { createContext, useContext, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const OffCanvasContext = createContext();
export const useOffCanvas = () => useContext(OffCanvasContext);

export const OffCanvasProvider = ({ children }) => {
  const [stack, setStack] = useState([]); // array of { id, component, props }

  const push = (layer) => setStack((s) => [...s, { id: Date.now(), ...layer }]);
  const pop = () => setStack((s) => s.slice(0, -1));
  const clear = () => setStack([]);

  return (
    <OffCanvasContext.Provider value={{ stack, push, pop, clear }}>
      {children}

      {/* Layered Panels */}
      <AnimatePresence>
        {stack.map((layer, idx) => {
          const isTop = idx === stack.length - 1;
          const Component = layer.component;

          return (
            <motion.div
              key={layer.id}
              className="offcanvas-layer"
              initial={{ y: "-100%", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: "-100%", opacity: 0 }}
              transition={{ type: "spring", damping: 20, stiffness: 200 }}
              style={{
                zIndex: 1100 + idx,
                position: "fixed",
                left: 0,
                right: 0,
                top: "0px", // sits above StickyAudioPlayer
                backgroundColor: "#000",
                borderBottom: "1px solid #000",
                borderBottomLeftRadius: "16px",
                borderBottomRightRadius: "16px",
                boxShadow: "0 6px 20px rgba(256, 256, 256, 0.7)",
                overflowY: "auto",
                minHeight: "40vh",
                maxHeight: "50vh",
              }}
            >
              <div className="offcanvas-content p-4">
                <Component {...layer.props} onClose={() => pop()} />
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      {/* Dimmed background overlay when something is open */}
      <AnimatePresence>
        {stack.length > 0 && (
          <motion.div
            key="offcanvas-overlay"
            className="offcanvas-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.4 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={() => pop()}
            style={{
              position: "fixed",
              inset: 0,
              background: "#000",
              zIndex: 1099,
            }}
          />
        )}
      </AnimatePresence>
    </OffCanvasContext.Provider>
  );
};
